import { render, staticRenderFns } from "./TimerInfo.vue?vue&type=template&id=4534b6b2&scoped=true"
import script from "./TimerInfo.vue?vue&type=script&lang=js"
export * from "./TimerInfo.vue?vue&type=script&lang=js"
import style0 from "./TimerInfo.vue?vue&type=style&index=0&id=4534b6b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4534b6b2",
  null
  
)

export default component.exports